var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEmpty)?_c('div',{staticClass:"base warning-bar"},[_vm._v("Needs Items")]):(_vm.isOpen)?_c('div',{staticClass:"base info-bar"},[_vm._v("Open")]):_c('div',{staticClass:"base"},[_vm._v("Allocated")])])}
var staticRenderFns = []

export { render, staticRenderFns }